import Vue from 'vue'
import config from '@/config'

if (config.env === 'development' || config.env === 'test') {
  Vue.directive('test', {
    bind(el, binding) {
      el.dataset.test = binding.value
    },
    update(el, binding) {
      el.dataset.test = binding.value
    }
  })
  Vue.directive('testId', {
    bind(el, binding) {
      el.dataset.testId = binding.value
    },
    update(el, binding) {
      el.dataset.testId = binding.value
    }
  })
} else {
  Vue.directive('test', {})
  Vue.directive('testId', {})
}
